/* SeattleWallWraps.com — reels feed, reels rail and the shared reel player (Builder B).
   Vanilla JS, no dependencies, one namespace: window.CWV.reels
   - Native video (Shopify-hosted / .mp4) is kept in inert <template>s and mounted only for the
     current reel and its neighbours (±1); it autoplays muted when >= 60% visible, pauses otherwise.
   - YouTube / Instagram / TikTok are facades: the iframe is injected only after a tap.
   - Every section instance is scoped to its own root, so the sections can appear several times. */
(function () {
  'use strict';

  var CWV = (window.CWV = window.CWV || {});
  if (CWV.reels) return; /* script tag is printed once per section instance */

  var doc = document;
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var mqCoarse = window.matchMedia ? window.matchMedia('(pointer: coarse)') : null;
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function noop() {}
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function reduced() { return !!(mqReduce && mqReduce.matches); }
  function saveData() { try { return !!(navigator.connection && navigator.connection.saveData); } catch (e) { return false; } }
  function canAutoplay() { return !reduced() && !saveData(); }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }
  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function smoothScroll(el, opts) {
    if (!el) return;
    if (reduced()) opts.behavior = 'auto';
    try { el.scrollTo(opts); } catch (e) { if (opts.top != null) el.scrollTop = opts.top; if (opts.left != null) el.scrollLeft = opts.left; }
  }
  function lockScroll(on) {
    if (typeof CWV.lockScroll === 'function') { CWV.lockScroll(on); return; }
    doc.documentElement.classList[on ? 'add' : 'remove']('cwv-scroll-lock');
  }

  /* Height of the sticky header (so the feed can sit right under it). */
  function headerOffset() {
    var cands = $$('.shopify-section-group-header-group, [data-cwv-header], .cwv-header, body > header');
    for (var i = 0; i < cands.length; i++) {
      var el = cands[i];
      var pos = window.getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') {
        var r = el.getBoundingClientRect();
        var top = parseFloat(window.getComputedStyle(el).top) || 0;
        return Math.max(0, Math.round(r.height + top));
      }
    }
    var v = parseFloat(window.getComputedStyle(doc.documentElement).getPropertyValue('--header-h'));
    return isNaN(v) ? 0 : v;
  }

  /* Clipboard with fallbacks: async API -> execCommand -> caller shows the URL to copy by hand. */
  function legacyCopy(text) {
    var ok = false, active = doc.activeElement;
    try {
      var ta = doc.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none;';
      doc.body.appendChild(ta);
      ta.select();
      ta.setSelectionRange(0, text.length);
      ok = doc.execCommand('copy');
      doc.body.removeChild(ta);
    } catch (e) { ok = false; }
    focusEl(active);
    return ok;
  }
  function copyText(text) {
    return new Promise(function (resolve) {
      try {
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function' && window.isSecureContext !== false) {
          navigator.clipboard.writeText(text).then(function () { resolve(true); }, function () { resolve(legacyCopy(text)); });
          return;
        }
      } catch (e) { /* fall through */ }
      resolve(legacyCopy(text));
    });
  }

  /* Accessible modal on top of <dialog>: focus trap, Esc, backdrop click, focus return, scroll lock. */
  function makeDialog(d, onClose) {
    var opener = null, open = false;
    var SEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),iframe,[tabindex]:not([tabindex="-1"])';
    function items() {
      return $$(SEL, d).filter(function (el) { return el.getClientRects().length > 0; });
    }
    function finish() {
      open = false;
      lockScroll(false);
      if (onClose) onClose();
      if (opener && doc.contains(opener)) focusEl(opener);
      opener = null;
    }
    d.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); api.close(); return; }
      if (e.key !== 'Tab') return;
      var list = items();
      if (!list.length) { e.preventDefault(); return; }
      var first = list[0], last = list[list.length - 1], a = doc.activeElement;
      if (e.shiftKey && (a === first || !d.contains(a))) { e.preventDefault(); focusEl(last); }
      else if (!e.shiftKey && (a === last || !d.contains(a))) { e.preventDefault(); focusEl(first); }
    });
    d.addEventListener('cancel', function (e) { e.preventDefault(); api.close(); });
    d.addEventListener('close', function () { if (open) finish(); });
    d.addEventListener('click', function (e) {
      var t = e.target;
      if (t === d || (t && t.hasAttribute && t.hasAttribute('data-cwv-backdrop'))) { api.close(); return; }
      var c = t && t.closest ? t.closest('[data-cwv-close]') : null;
      if (c && d.contains(c)) api.close();
    });
    var api = {
      open: function (from) {
        if (open) return;
        opener = from || doc.activeElement;
        open = true;
        if (typeof d.showModal === 'function') { try { d.showModal(); } catch (e) { d.setAttribute('open', ''); } }
        else d.setAttribute('open', '');
        lockScroll(true);
        focusEl($('[data-cwv-autofocus]', d) || items()[0]);
      },
      close: function () {
        if (!open) return;
        if (typeof d.close === 'function' && d.open) { try { d.close(); } catch (e) { d.removeAttribute('open'); } }
        else d.removeAttribute('open');
        if (open) finish();
      },
      isOpen: function () { return open; },
      returnTo: function (el) { if (el) opener = el; }
    };
    return api;
  }

  /* ======================================================================
     Media — one reel's player (markup from snippets/cwv-reel-media.liquid)
     ====================================================================== */
  function Media(el, opts) {
    this.el = el;
    this.opts = opts || {};
    this.kind = el.getAttribute('data-kind') || 'none';
    this.title = el.getAttribute('data-title') || 'video';
    this.slot = $('[data-cwv-slot]', el);
    this.bar = $('[data-cwv-progress]', el);
    this.tapBtn = $('[data-cwv-tap]', el);
    this.muteBtn = $('[data-cwv-mute]', el);
    this.video = null;
    this.iframe = null;
    this.userPaused = false;
    if (this.kind === 'native' && !canAutoplay()) el.classList.add('is-manual');
  }
  Media.prototype.setState = function (s) {
    this.el.setAttribute('data-state', s);
    if (this.tapBtn) this.tapBtn.setAttribute('aria-label', (s === 'playing' ? 'Pause: ' : 'Play: ') + this.title);
  };
  Media.prototype.mount = function (preload) {
    if (this.kind !== 'native' || !this.slot) return null;
    if (this.video) {
      if (preload === 'auto') this.video.preload = 'auto';
      return this.video;
    }
    var tpl = $('template[data-cwv-video]', this.el);
    if (!tpl || !tpl.content) return null;
    var frag = tpl.content.cloneNode(true);
    var v = frag.querySelector('video');
    if (!v) return null;
    v.removeAttribute('autoplay');
    v.removeAttribute('controls');
    v.removeAttribute('poster'); /* the lazy poster <img> underneath is the poster */
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
    v.loop = true;
    v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.setAttribute('tabindex', '-1');
    v.setAttribute('aria-hidden', 'true');
    v.preload = preload || 'metadata';
    var self = this;
    v.addEventListener('playing', function () {
      if (self.video !== v) return;
      self.el.setAttribute('data-ready', '');
      self.el.removeAttribute('data-buffering');
      self.setState('playing');
      if (self.opts.onPlaying) self.opts.onPlaying(self);
    });
    v.addEventListener('pause', function () { if (self.video === v) self.setState('paused'); });
    v.addEventListener('waiting', function () { if (self.video === v && !v.paused) self.el.setAttribute('data-buffering', ''); });
    v.addEventListener('canplay', function () { self.el.removeAttribute('data-buffering'); });
    v.addEventListener('timeupdate', function () {
      if (self.bar && v.duration) self.bar.style.transform = 'scaleX(' + Math.min(1, v.currentTime / v.duration).toFixed(4) + ')';
    });
    v.addEventListener('error', function () { if (self.video === v) { self.el.removeAttribute('data-buffering'); self.setState('error'); } }, true);
    this.slot.appendChild(frag);
    this.video = v;
    return v;
  };
  Media.prototype.unmount = function () {
    var v = this.video;
    if (!v) return;
    this.video = null;
    try { v.pause(); } catch (e) {}
    $$('source', v).forEach(function (s) { s.parentNode.removeChild(s); });
    v.removeAttribute('src');
    try { v.load(); } catch (e) {}
    if (v.parentNode) v.parentNode.removeChild(v);
    this.el.removeAttribute('data-ready');
    this.el.removeAttribute('data-buffering');
    if (this.bar) this.bar.style.transform = 'scaleX(0)';
    this.userPaused = false;
    this.setState('idle');
  };
  Media.prototype.play = function (muted) {
    var v = this.mount('auto');
    if (!v) return;
    var self = this;
    v.muted = !!muted;
    this.syncMute(v.muted);
    var p;
    try { p = v.play(); } catch (e) { p = null; }
    if (p && typeof p.then === 'function') {
      p.catch(function (err) {
        if (self.video !== v) return;
        if (err && err.name === 'NotAllowedError' && !v.muted) {
          /* sound blocked by the browser: fall back to muted playback */
          v.muted = true;
          self.syncMute(true);
          if (self.opts.onForcedMute) self.opts.onForcedMute(self);
          v.play().catch(function () { if (self.video === v) self.setState('paused'); });
        } else if (!err || err.name !== 'AbortError') {
          self.setState('paused');
        }
      });
    }
  };
  Media.prototype.pause = function () { if (this.video) { try { this.video.pause(); } catch (e) {} } };
  Media.prototype.isPlaying = function () { return !!(this.video && !this.video.paused && !this.video.ended); };
  Media.prototype.syncMute = function (m) { if (this.muteBtn) this.muteBtn.setAttribute('aria-pressed', m ? 'true' : 'false'); };
  Media.prototype.setMuted = function (m) { if (this.video) this.video.muted = m; this.syncMute(m); };
  Media.prototype.toggle = function (muted) {
    if (this.isPlaying()) { this.userPaused = true; this.pause(); }
    else { this.userPaused = false; this.play(muted); }
  };
  Media.prototype.loadEmbed = function (focus) {
    if (this.kind !== 'embed' || this.iframe || !this.slot) return;
    var tpl = $('template[data-cwv-embed]', this.el);
    if (!tpl || !tpl.content) return;
    var frag = tpl.content.cloneNode(true);
    var f = frag.querySelector('iframe');
    if (!f) return;
    this.slot.appendChild(frag);
    this.iframe = f;
    this.setState('embed');
    if (focus) focusEl(f);
  };
  Media.prototype.unloadEmbed = function () {
    if (!this.iframe) return;
    if (this.iframe.parentNode) this.iframe.parentNode.removeChild(this.iframe);
    this.iframe = null;
    this.setState('idle');
  };
  Media.prototype.stop = function () {
    if (this.kind === 'native') { this.userPaused = false; this.pause(); }
    else this.unloadEmbed();
  };
  Media.prototype.destroy = function () { this.unmount(); this.unloadEmbed(); };

  /* ======================================================================
     Feed — sections/cwv-reels-feed.liquid
     ====================================================================== */
  var feedCount = 0;

  function Feed(root) {
    this.root = root;
    this.wrap = $('[data-cwv-wrap]', root);
    this.viewport = $('[data-cwv-viewport]', root);
    if (!this.viewport) return;
    var self = this;
    this.slides = $$('[data-cwv-slide]', this.viewport);
    this.reels = this.slides.filter(function (s) { return s.hasAttribute('data-cwv-reel'); });
    this.muted = true;
    this.inView = !hasIO;
    this.current = null;
    this.target = null;
    this.moved = false;
    this.announceNext = false;
    this.currentEl = $('[data-cwv-current]', root);
    this.totalEl = $('[data-cwv-total]', root);
    this.navPrev = $('[data-cwv-prev][data-cwv-navbtn]', root);
    this.navNext = $('[data-cwv-next][data-cwv-navbtn]', root);
    this.announcer = $('[data-cwv-announce]', root);
    this.toast = $('[data-cwv-toast]', root);

    this.reels.forEach(function (r) {
      var m = $('[data-cwv-media]', r);
      r.cwvMedia = m ? new Media(m, {
        onForcedMute: function () { self.setMuted(true); },
        onPlaying: function () { self.root.classList.add('has-played'); }
      }) : null;
    });

    feedCount += 1;
    if (feedCount > 1) {
      /* keep #reel-N unique when the feed appears more than once on a page */
      var pre = 'reel-' + feedCount + '-';
      this.reels.forEach(function (r) { r.id = pre + r.getAttribute('data-n'); });
    }

    this.measure();
    this.bind();
    this.observe();
    var first = this.visibleSlides()[0];
    if (first && !this.handleHash(true)) this.setCurrent(first, true);
  }

  Feed.prototype.visibleSlides = function () { return this.slides.filter(function (s) { return !s.hidden; }); };
  Feed.prototype.visibleReels = function () { return this.reels.filter(function (s) { return !s.hidden; }); };

  Feed.prototype.measure = function () {
    var off = headerOffset();
    if (this.offset === off) return;
    this.offset = off;
    this.root.style.setProperty('--rf-offset', off + 'px');
  };

  Feed.prototype.bind = function () {
    var self = this, root = this.root;

    this.onClick = function (e) {
      var t = e.target && e.target.closest ? e.target.closest('button') : null;
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-cwv-filter')) { self.setFilter(t.getAttribute('data-cwv-filter')); return; }
      if (t.hasAttribute('data-cwv-next')) { self.announceNext = true; self.go(1); return; }
      if (t.hasAttribute('data-cwv-prev')) { self.announceNext = true; self.go(-1); return; }
      if (t.hasAttribute('data-cwv-top')) { self.announceNext = true; self.goTo(self.visibleSlides()[0]); focusEl(self.viewport); return; }
      var reel = t.closest('[data-cwv-reel]');
      if (!reel) return;
      if (t.hasAttribute('data-cwv-share')) { self.share(reel, t); return; }
      if (t.hasAttribute('data-cwv-mute')) { self.setMuted(!self.muted); return; }
      if (t.hasAttribute('data-cwv-tap')) { self.tap(reel); return; }
      if (t.hasAttribute('data-cwv-play')) { self.playEmbed(reel); }
    };
    root.addEventListener('click', this.onClick);

    this.onKey = function (e) {
      if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
      var t = e.target;
      if (!self.wrap || !self.wrap.contains(t)) return; /* only when the feed itself has focus */
      if (/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName) || t.isContentEditable) return;
      var list;
      switch (e.key) {
        case 'ArrowDown': case 'PageDown': case 'Down':
          e.preventDefault(); self.announceNext = true; self.go(1); break;
        case 'ArrowUp': case 'PageUp': case 'Up':
          e.preventDefault(); self.announceNext = true; self.go(-1); break;
        case 'Home':
          if (t === self.viewport) { e.preventDefault(); self.announceNext = true; self.goTo(self.visibleSlides()[0]); }
          break;
        case 'End':
          if (t === self.viewport) { list = self.visibleSlides(); e.preventDefault(); self.announceNext = true; self.goTo(list[list.length - 1]); }
          break;
        case 'm': case 'M':
          e.preventDefault(); self.setMuted(!self.muted); break;
        case ' ': case 'Spacebar':
          if (t === self.viewport && self.current && self.current.cwvMedia) {
            e.preventDefault();
            var m = self.current.cwvMedia;
            if (m.kind === 'native') self.tap(self.current);
            else if (m.kind === 'embed') self.playEmbed(self.current);
          }
          break;
      }
    };
    root.addEventListener('keydown', this.onKey);

    this.onResize = debounce(function () {
      self.measure();
      if (self.current) self.viewport.scrollTop = self.current.offsetTop;
    }, 150);
    window.addEventListener('resize', this.onResize);

    this.onHash = function () { self.handleHash(false); };
    window.addEventListener('hashchange', this.onHash);

    this.onVis = function () { if (doc.hidden) self.pauseCurrent(); else self.resume(); };
    doc.addEventListener('visibilitychange', this.onVis);

    if (!hasIO) this.viewport.addEventListener('scroll', debounce(function () { self.pickByScroll(); }, 80), { passive: true });
  };

  Feed.prototype.observe = function () {
    if (!hasIO) return;
    var self = this;
    this.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var s = en.target;
        if (s.hidden) return;
        if (en.isIntersecting && en.intersectionRatio >= 0.6) {
          if (self.target && s !== self.target) return; /* programmatic jump in progress */
          if (s === self.target) self.target = null;
          self.setCurrent(s);
        } else if (s === self.current) {
          self.pauseCurrent(true); /* mid-swipe: pause, keep embeds until another reel takes over */
        }
      });
    }, { root: this.viewport, threshold: [0, 0.6] });
    this.slides.forEach(function (s) { self.io.observe(s); });

    this.pageIo = new IntersectionObserver(function (entries) {
      var en = entries[entries.length - 1];
      var vis = en.isIntersecting && en.intersectionRatio >= 0.5;
      if (vis === self.inView) return;
      self.inView = vis;
      if (vis) self.resume();
      else self.pauseCurrent(false);
    }, { threshold: [0, 0.5] });
    this.pageIo.observe(this.viewport);
  };

  /* Fallback for browsers without IntersectionObserver. */
  Feed.prototype.pickByScroll = function () {
    var top = this.viewport.scrollTop, best = null, bd = Infinity;
    this.visibleSlides().forEach(function (s) { var d = Math.abs(s.offsetTop - top); if (d < bd) { bd = d; best = s; } });
    if (best) this.setCurrent(best);
  };

  Feed.prototype.setCurrent = function (slide, initial) {
    if (!slide) return;
    var prev = this.current;
    if (slide === prev) { this.resume(); return; }
    this.current = slide;
    if (prev) {
      prev.classList.remove('is-active');
      if (prev.cwvMedia) prev.cwvMedia.stop();
    }
    slide.classList.add('is-active');

    /* keep at most the current reel ±1 mounted */
    var list = this.visibleSlides(), i = list.indexOf(slide), auto = canAutoplay();
    this.reels.forEach(function (r) {
      var m = r.cwvMedia;
      if (!m || m.kind !== 'native') return;
      var j = list.indexOf(r);
      if (j < 0 || Math.abs(j - i) > 1) m.unmount();
      else if (r !== slide && auto) m.mount('metadata');
    });

    this.updateUi(list);
    if (!initial && prev) {
      if (!this.moved) { this.moved = true; this.root.classList.add('has-moved'); }
      this.align();
    }
    if (this.announceNext) { this.announce(slide); this.announceNext = false; }
    this.resume();
  };

  Feed.prototype.updateUi = function (list) {
    var reels = this.visibleReels();
    var ri = reels.indexOf(this.current);
    if (this.currentEl) this.currentEl.textContent = ri >= 0 ? pad(ri + 1) : '··';
    if (this.totalEl) this.totalEl.textContent = pad(reels.length);
    var i = list.indexOf(this.current);
    if (this.navPrev) this.navPrev.disabled = i <= 0;
    if (this.navNext) this.navNext.disabled = i >= list.length - 1;
  };

  Feed.prototype.announce = function (slide) {
    if (!this.announcer) return;
    var reels = this.visibleReels(), ri = reels.indexOf(slide);
    this.announcer.textContent = ri >= 0
      ? 'Reel ' + (ri + 1) + ' of ' + reels.length + ': ' + (slide.getAttribute('data-title') || '')
      : 'End of feed';
  };

  Feed.prototype.resume = function () {
    var s = this.current;
    if (!s || !s.cwvMedia || !this.inView || doc.hidden) return;
    var m = s.cwvMedia;
    if (m.kind === 'native' && canAutoplay() && !m.userPaused && !m.isPlaying()) m.play(this.muted);
  };

  Feed.prototype.pauseCurrent = function (keepEmbeds) {
    var s = this.current;
    if (!s || !s.cwvMedia) return;
    if (s.cwvMedia.kind === 'native') s.cwvMedia.pause();
    else if (!keepEmbeds) s.cwvMedia.unloadEmbed();
  };

  Feed.prototype.tap = function (reel) {
    if (reel !== this.current) { this.goTo(reel); return; }
    var m = reel.cwvMedia;
    if (!m || m.kind !== 'native') return;
    m.toggle(this.muted);
  };

  Feed.prototype.playEmbed = function (reel) {
    var m = reel.cwvMedia;
    if (!m) return;
    if (reel !== this.current) this.goTo(reel);
    if (m.kind === 'embed') { m.loadEmbed(true); reel.classList.add('is-playing-embed'); }
    else if (m.kind === 'native') { m.userPaused = false; m.play(this.muted); }
  };

  Feed.prototype.setMuted = function (m) {
    this.muted = !!m;
    this.root.setAttribute('data-muted', this.muted ? 'true' : 'false');
    var self = this;
    this.reels.forEach(function (r) { if (r.cwvMedia && r.cwvMedia.kind === 'native') r.cwvMedia.setMuted(self.muted); });
    var cur = this.current && this.current.cwvMedia;
    /* unmuting is a user gesture: make sure the current video is actually playing with sound */
    if (!this.muted && cur && cur.kind === 'native' && !cur.isPlaying()) { cur.userPaused = false; cur.play(false); }
  };

  Feed.prototype.go = function (dir) {
    var list = this.visibleSlides();
    if (!list.length) return;
    var i = list.indexOf(this.current);
    if (i < 0) i = 0;
    var j = Math.max(0, Math.min(list.length - 1, i + dir));
    if (j !== i) this.goTo(list[j]);
    else this.align();
  };

  Feed.prototype.goTo = function (slide, instant) {
    if (!slide) return;
    var self = this;
    this.align(instant);
    this.target = slide;
    clearTimeout(this.targetTimer);
    this.targetTimer = setTimeout(function () { if (self.target === slide) { self.target = null; self.setCurrent(slide); } }, 900);
    if (instant) this.viewport.scrollTop = slide.offsetTop;
    else smoothScroll(this.viewport, { top: slide.offsetTop, behavior: 'smooth' });
    if (!hasIO || instant) { this.target = null; this.setCurrent(slide); }
  };

  /* Bring the feed flush under the sticky header so one reel fills the screen. */
  Feed.prototype.align = function (instant) {
    if (designMode()) return;
    this.measure();
    var r = this.viewport.getBoundingClientRect();
    var delta = r.top - this.offset;
    if (Math.abs(delta) < 6) return;
    if (r.bottom < 0 || r.top > window.innerHeight) return;
    smoothScroll(window, { top: (window.pageYOffset || doc.documentElement.scrollTop) + delta, behavior: instant ? 'auto' : 'smooth' });
  };

  Feed.prototype.setFilter = function (key) {
    var shown = 0, label = 'All';
    $$('[data-cwv-filter]', this.root).forEach(function (b) {
      var on = b.getAttribute('data-cwv-filter') === key;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) label = b.textContent.trim();
    });
    this.reels.forEach(function (r) {
      var on = key === 'all' || r.getAttribute('data-cat') === key;
      r.hidden = !on;
      if (on) shown += 1;
    });
    var cur = this.current;
    if (cur && cur.hidden) {
      cur.classList.remove('is-active');
      if (cur.cwvMedia) cur.cwvMedia.stop();
      this.current = null;
    }
    this.target = null;
    this.viewport.scrollTop = 0;
    var first = this.visibleSlides()[0];
    if (first) this.setCurrent(first, true);
    if (this.announcer) this.announcer.textContent = 'Showing ' + shown + (shown === 1 ? ' reel' : ' reels') + (key === 'all' ? '' : ': ' + label);
  };

  Feed.prototype.share = function (reel, btn) {
    var url = location.href.split('#')[0] + '#' + reel.id;
    var title = reel.getAttribute('data-title') || doc.title;
    var self = this;
    if (navigator.share && mqCoarse && mqCoarse.matches) {
      navigator.share({ title: title, url: url }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        self.copyLink(url, btn);
      });
      return;
    }
    this.copyLink(url, btn);
  };

  Feed.prototype.copyLink = function (url, btn) {
    var self = this;
    copyText(url).then(function (ok) {
      if (ok) self.showToast('Link copied to clipboard');
      else self.showToast(null, url);
      if (ok && btn) focusEl(btn);
    });
  };

  Feed.prototype.showToast = function (msg, url) {
    var t = this.toast;
    if (!t) return;
    clearTimeout(this.toastTimer);
    t.textContent = '';
    if (url) {
      var lab = doc.createElement('label');
      lab.appendChild(doc.createTextNode('Copy this link: '));
      var inp = doc.createElement('input');
      inp.type = 'text'; inp.readOnly = true; inp.value = url;
      lab.appendChild(inp);
      t.appendChild(lab);
      setTimeout(function () { try { inp.focus(); inp.select(); } catch (e) {} }, 30);
    } else {
      t.textContent = msg;
    }
    t.classList.add('is-on');
    this.toastTimer = setTimeout(function () {
      t.classList.remove('is-on');
      setTimeout(function () { if (!t.classList.contains('is-on')) t.textContent = ''; }, 300);
    }, url ? 8000 : 2400);
  };

  /* Deep link: #reel-N scrolls the page to the feed and the feed to that reel. */
  Feed.prototype.handleHash = function (initial) {
    var h = location.hash;
    if (!h || h.length < 2) return false;
    var id;
    try { id = decodeURIComponent(h.slice(1)); } catch (e) { return false; }
    var el = doc.getElementById(id);
    if (!el || this.reels.indexOf(el) < 0) return false;
    if (el.hidden) this.setFilter('all');
    var self = this;
    var run = function () {
      var r = self.viewport.getBoundingClientRect();
      smoothScroll(window, { top: (window.pageYOffset || doc.documentElement.scrollTop) + r.top - headerOffset(), behavior: 'auto' });
      self.target = null;
      self.viewport.scrollTop = el.offsetTop;
      self.setCurrent(el, true);
    };
    run();
    if (initial) {
      window.requestAnimationFrame(run);
      window.addEventListener('load', run, { once: true });
    }
    return true;
  };

  Feed.prototype.selectBlock = function (el) {
    var reel = el.closest ? el.closest('[data-cwv-reel]') : null;
    if (!reel || this.reels.indexOf(reel) < 0) return;
    if (reel.hidden) this.setFilter('all');
    this.goTo(reel, true);
  };

  Feed.prototype.destroy = function () {
    if (this.io) this.io.disconnect();
    if (this.pageIo) this.pageIo.disconnect();
    this.root.removeEventListener('click', this.onClick);
    this.root.removeEventListener('keydown', this.onKey);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('hashchange', this.onHash);
    doc.removeEventListener('visibilitychange', this.onVis);
    clearTimeout(this.toastTimer);
    clearTimeout(this.targetTimer);
    this.reels.forEach(function (r) { if (r.cwvMedia) r.cwvMedia.destroy(); });
    feedCount = Math.max(0, feedCount - 1);
  };

  /* ======================================================================
     Rail — sections/cwv-reels-rail.liquid (+ fullscreen modal player)
     ====================================================================== */
  function Rail(root) {
    this.root = root;
    this.track = $('[data-cwv-track]', root);
    this.cards = $$('[data-cwv-card]', root);
    this.dlgEl = $('[data-cwv-dialog]', root);
    if (!this.track || !this.cards.length) return;
    var self = this;
    this.inView = !hasIO;
    this.center = null;
    this.pv = null;
    this.pvCard = null;
    this.idx = -1;
    this.media = null;
    this.muted = false;

    this.onTrackClick = function (e) {
      var c = e.target && e.target.closest ? e.target.closest('[data-cwv-card]') : null;
      if (!c || !self.track.contains(c)) return;
      e.preventDefault();
      self.open(self.cards.indexOf(c), c);
    };
    this.track.addEventListener('click', this.onTrackClick);

    this.onTrackKey = function (e) {
      var c = e.target && e.target.closest ? e.target.closest('[data-cwv-card]') : null;
      if (!c) return;
      var i = self.cards.indexOf(c), j = -1;
      if (e.key === 'ArrowRight') j = i + 1;
      else if (e.key === 'ArrowLeft') j = i - 1;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = self.cards.length - 1;
      if (j < 0 || j >= self.cards.length) return;
      e.preventDefault();
      focusEl(self.cards[j]);
      self.cards[j].parentNode.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduced() ? 'auto' : 'smooth' });
    };
    this.track.addEventListener('keydown', this.onTrackKey);

    var ticking = false;
    this.onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; self.updateCenter(); });
    };
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.onResize = debounce(function () { self.updateCenter(); }, 150);
    window.addEventListener('resize', this.onResize);

    this.onArrow = function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-cwv-rail-prev],[data-cwv-rail-next]') : null;
      if (!b || !root.contains(b)) return;
      var dir = b.hasAttribute('data-cwv-rail-next') ? 1 : -1;
      var gap = parseFloat(window.getComputedStyle(self.track).columnGap) || 16;
      var step = (self.cards[0].parentNode.offsetWidth + gap) * 2;
      smoothScroll(self.track, { left: self.track.scrollLeft + dir * step, behavior: 'smooth' });
    };
    root.addEventListener('click', this.onArrow);

    if (hasIO) {
      this.io = new IntersectionObserver(function (entries) {
        var en = entries[entries.length - 1];
        self.inView = en.isIntersecting && en.intersectionRatio >= 0.35;
        if (self.inView) self.preview(); else self.stopPreview();
      }, { threshold: [0, 0.35] });
      this.io.observe(this.track);
    }

    this.onVis = function () { if (doc.hidden) self.stopPreview(); else self.preview(); };
    doc.addEventListener('visibilitychange', this.onVis);

    if (this.dlgEl) this.setupDialog();
    this.updateCenter();
  }

  Rail.prototype.updateCenter = function () {
    var t = this.track, mid = t.scrollLeft + t.clientWidth / 2, best = null, bd = Infinity;
    this.cards.forEach(function (c) {
      var li = c.parentNode;
      var d = Math.abs(li.offsetLeft + li.offsetWidth / 2 - mid);
      if (d < bd) { bd = d; best = c; }
    });
    if (best === this.center) return;
    if (this.center) this.center.classList.remove('is-center');
    this.stopPreview();
    this.center = best;
    if (best) best.classList.add('is-center');
    this.preview();
  };

  /* Muted live preview on the center card (native video reels only). */
  Rail.prototype.preview = function () {
    var c = this.center;
    if (!c || !this.inView || doc.hidden || !canAutoplay() || (this.dlg && this.dlg.isOpen())) return;
    if (this.pvCard === c && this.pv) { this.pv.play().catch(noop); return; }
    var tpl = $('template[data-cwv-tpl]', c.parentNode);
    var vt = tpl && tpl.content ? tpl.content.querySelector('template[data-cwv-video]') : null;
    if (!vt || !vt.content) return;
    var v = vt.content.cloneNode(true).querySelector('video');
    var slot = $('[data-cwv-preview]', c);
    if (!v || !slot) return;
    v.removeAttribute('autoplay'); v.removeAttribute('controls'); v.removeAttribute('poster');
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
    v.loop = true; v.playsInline = true; v.setAttribute('playsinline', '');
    v.setAttribute('tabindex', '-1'); v.setAttribute('aria-hidden', 'true');
    v.preload = 'auto';
    var bar = $('[data-cwv-bar]', c), now = $('[data-cwv-now]', c);
    v.addEventListener('playing', function () { c.classList.add('is-previewing'); if (now) now.textContent = 'Now playing'; });
    v.addEventListener('timeupdate', function () { if (bar && v.duration) bar.style.transform = 'scaleX(' + Math.min(1, v.currentTime / v.duration).toFixed(4) + ')'; });
    slot.appendChild(v);
    this.pv = v;
    this.pvCard = c;
    var p = v.play();
    if (p && p.catch) p.catch(noop);
  };

  Rail.prototype.stopPreview = function () {
    var v = this.pv, c = this.pvCard;
    this.pv = null; this.pvCard = null;
    if (v) {
      try { v.pause(); } catch (e) {}
      $$('source', v).forEach(function (s) { s.parentNode.removeChild(s); });
      v.removeAttribute('src');
      try { v.load(); } catch (e) {}
      if (v.parentNode) v.parentNode.removeChild(v);
    }
    if (c) {
      c.classList.remove('is-previewing');
      var now = $('[data-cwv-now]', c), bar = $('[data-cwv-bar]', c);
      if (now) now.textContent = 'Tap to play';
      if (bar) bar.style.transform = 'scaleX(0)';
    }
  };

  Rail.prototype.setupDialog = function () {
    var self = this, d = this.dlgEl;
    this.stage = $('[data-cwv-stage]', d);
    this.dTitle = $('[data-cwv-d-title]', d);
    this.dMeta = $('[data-cwv-d-meta]', d);
    this.dCaption = $('[data-cwv-d-caption]', d);
    this.dExt = $('[data-cwv-d-ext]', d);
    this.dStatus = $('[data-cwv-d-status]', d);
    this.dlg = makeDialog(d, function () {
      if (self.media) { self.media.destroy(); self.media = null; }
      if (self.stage) self.stage.innerHTML = '';
      self.idx = -1;
      self.preview();
    });

    d.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button') : null;
      if (!b || !d.contains(b)) return;
      if (b.hasAttribute('data-cwv-dnext')) { self.show(self.idx + 1); return; }
      if (b.hasAttribute('data-cwv-dprev')) { self.show(self.idx - 1); return; }
      if (!self.media) return;
      if (b.hasAttribute('data-cwv-mute')) { self.setMuted(!self.muted); return; }
      if (b.hasAttribute('data-cwv-tap')) { self.media.toggle(self.muted); return; }
      if (b.hasAttribute('data-cwv-play')) { self.media.loadEmbed(false); }
    });

    d.addEventListener('keydown', function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      var t = e.target;
      if (t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight' || e.key === 'PageDown') { e.preventDefault(); self.show(self.idx + 1); }
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft' || e.key === 'PageUp') { e.preventDefault(); self.show(self.idx - 1); }
      else if (e.key === 'm' || e.key === 'M') { e.preventDefault(); self.setMuted(!self.muted); }
    });

    /* swipe up / down (or left / right) to change reels on touch screens */
    var sx = 0, sy = 0, st = 0;
    d.addEventListener('touchstart', function (e) {
      var p = e.touches && e.touches[0];
      if (!p) return;
      sx = p.clientX; sy = p.clientY; st = Date.now();
    }, { passive: true });
    d.addEventListener('touchend', function (e) {
      var p = e.changedTouches && e.changedTouches[0];
      if (!p || Date.now() - st > 800) return;
      var dx = p.clientX - sx, dy = p.clientY - sy;
      if (Math.abs(dy) > 60 && Math.abs(dy) > Math.abs(dx)) self.show(self.idx + (dy < 0 ? 1 : -1));
      else if (Math.abs(dx) > 60) self.show(self.idx + (dx < 0 ? 1 : -1));
    }, { passive: true });
  };

  Rail.prototype.open = function (i, opener) {
    if (!this.dlg) return;
    this.stopPreview();
    this.dlg.open(opener);
    this.show(i);
  };

  Rail.prototype.show = function (i) {
    var n = this.cards.length;
    if (!n || !this.stage) return;
    i = ((i % n) + n) % n;
    if (this.media) { this.media.destroy(); this.media = null; }
    this.stage.innerHTML = '';
    if (this.dExt) this.dExt.innerHTML = '';

    var card = this.cards[i];
    var tpl = $('template[data-cwv-tpl]', card.parentNode);
    if (tpl && tpl.content) {
      var frag = tpl.content.cloneNode(true);
      var mediaWrap = frag.querySelector('[data-cwv-tpl-media]');
      var ext = frag.querySelector('[data-cwv-tpl-ext]');
      if (mediaWrap) this.stage.appendChild(mediaWrap);
      if (ext && this.dExt) { while (ext.firstChild) this.dExt.appendChild(ext.firstChild); }
    }

    var title = card.getAttribute('data-title') || 'Reel';
    var cat = card.getAttribute('data-cat') || '';
    var dur = card.getAttribute('data-duration') || '';
    if (this.dTitle) this.dTitle.textContent = title;
    if (this.dCaption) this.dCaption.textContent = card.getAttribute('data-caption') || '';
    if (this.dMeta) this.dMeta.textContent = 'Reel ' + pad(i + 1) + ' / ' + pad(n) + (cat ? ' · ' + cat : '') + (dur ? ' · ' + dur : '');
    if (this.dStatus) this.dStatus.textContent = 'Reel ' + (i + 1) + ' of ' + n + ': ' + title;

    var self = this, mEl = $('[data-cwv-media]', this.stage);
    this.media = mEl ? new Media(mEl, { onForcedMute: function () { self.muted = true; } }) : null;
    this.idx = i;
    if (this.media) {
      this.media.syncMute(this.muted);
      /* the viewer clicked a card: start right away (embeds load on this tap) */
      if (this.media.kind === 'native') this.media.play(this.muted);
      else if (this.media.kind === 'embed') this.media.loadEmbed(false);
    }
    /* keep the rail in sync (horizontal only, so the page behind the modal does not move) */
    var li = card.parentNode, tr = this.track;
    if (li && tr) tr.scrollLeft = Math.max(0, li.offsetLeft - (tr.clientWidth - li.offsetWidth) / 2);
    if (this.dlg) this.dlg.returnTo(card);
  };

  Rail.prototype.setMuted = function (m) {
    this.muted = !!m;
    if (this.media) {
      this.media.setMuted(this.muted);
      if (!this.muted && this.media.kind === 'native' && !this.media.isPlaying()) this.media.play(false);
    }
  };

  Rail.prototype.selectBlock = function (el) {
    var c = el.closest ? el.closest('[data-cwv-card]') : null;
    if (!c && el.querySelector) c = el.querySelector('[data-cwv-card]');
    if (!c || this.cards.indexOf(c) < 0) return;
    try { c.parentNode.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch (e) {}
    this.updateCenter();
  };

  Rail.prototype.destroy = function () {
    if (this.dlg && this.dlg.isOpen()) this.dlg.close();
    this.stopPreview();
    if (this.io) this.io.disconnect();
    if (this.track) {
      this.track.removeEventListener('click', this.onTrackClick);
      this.track.removeEventListener('keydown', this.onTrackKey);
      this.track.removeEventListener('scroll', this.onScroll);
    }
    this.root.removeEventListener('click', this.onArrow);
    window.removeEventListener('resize', this.onResize);
    doc.removeEventListener('visibilitychange', this.onVis);
    if (this.media) this.media.destroy();
  };

  /* ======================================================================
     Boot + theme editor hooks
     ====================================================================== */
  function init(scope) {
    $$('[data-cwv-reels-feed]', scope).forEach(function (el) { if (!el.cwvReels) el.cwvReels = new Feed(el); });
    $$('[data-cwv-reels-rail]', scope).forEach(function (el) { if (!el.cwvReels) el.cwvReels = new Rail(el); });
  }
  function destroy(scope) {
    $$('[data-cwv-reels-feed],[data-cwv-reels-rail]', scope).forEach(function (el) {
      if (el.cwvReels && el.cwvReels.destroy) el.cwvReels.destroy();
      el.cwvReels = null;
    });
  }

  CWV.reels = { init: init, destroy: destroy, Media: Media, copyText: copyText };

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);

  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  doc.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
  doc.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    var root = t && t.closest ? t.closest('[data-cwv-reels-feed],[data-cwv-reels-rail]') : null;
    if (root && root.cwvReels && root.cwvReels.selectBlock) root.cwvReels.selectBlock(t);
  });
})();
